import {
  INotificationModel,
  INotificationListModel,
  INotificationSearchFilterModel,
  IUserNotificationSearchFilterModel,
  IUserNotificationListModel,
  INotificationSendModel,
} from "../../models";
import { SimpleServiceBase } from "../Base";
import { Observable, Observer } from "rxjs";
import { map } from "rxjs/operators";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";

const sanitizeDates = (notification: INotificationModel): INotificationModel => {
  if (notification.ScheduledOn) {
    const year = new Date(notification.ScheduledOn.toString()).getFullYear();
    if (year < 1900 || year > 2100) {
      notification.ScheduledOn = undefined;
    }
  }

  if (notification.SentOn) {
    const year = new Date(notification.SentOn.toString()).getFullYear();
    if (year < 1900 || year > 2100) {
      notification.SentOn = undefined;
    }
  }

  return notification;
};

export class NotificationsService extends SimpleServiceBase<
  INotificationModel,
  INotificationListModel,
  number,
  INotificationSearchFilterModel
> {
  get url(): string {
    return "/Notifications";
  }

  public get = (id: number): Observable<INotificationModel> =>
    new Observable(
      (observer: Observer<INotificationModel>) => {
        if (!id) {
          observer.next({} as INotificationModel);
          observer.complete();
          return;
        }
        return new AxiosSubscriber(observer, {
          axiosConfig: {
            params: {
              id,
            },
          },
          method: HTTP_METHOD.GET,
          url: `${this.url}/Get`,
        })
      }
    ).pipe(map(sanitizeDates));

  public search = (
    filter: INotificationSearchFilterModel = {} as INotificationSearchFilterModel,
    params = {}
  ): Observable<INotificationListModel> =>
    new Observable(
      (observer: Observer<INotificationListModel>) =>
        new AxiosSubscriber(observer, {
          data: filter,
          method: HTTP_METHOD.POST,
          url: `${this.url}/Search`,
        })
    ).pipe(
      map((result) => ({
        ...result,
        Entities: result.Entities?.map(sanitizeDates),
      }))
    );

  public searchUserNotifications = (
    filter: IUserNotificationSearchFilterModel
  ): Observable<IUserNotificationListModel> =>
    new Observable(
      (observer: Observer<IUserNotificationListModel>) =>
        new AxiosSubscriber(observer, {
          data: filter,
          method: HTTP_METHOD.POST,
          url: `${this.url}/SearchUserNotifications`,
        })
    );

  public send = (filter: INotificationSendModel): Observable<void> =>
    new Observable(
      (observer: Observer<void>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.POST,
          url: `${this.url}/Send?id=${filter.Id}&rowVersion=${filter.RowVersion}`,
        })
    );

  public duplicate = (id: number): Observable<void> =>
    new Observable(
      (observer: Observer<void>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.POST,
          url: `${this.url}/Duplicated?id=${id}`,
        })
    );

  /* public delete = (data: INotificationModel): Observable<void> =>
    new Observable(
      (observer: Observer<void>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.DELETE,
          url: `${this.url}/${data.Id}`,
        })
    ); */
}
